import { q } from 'bobjoll/ts/library/dom';

export const initFontsView = () => {
    const switchButtonFonts = q('.switch-button-fonts');
    if (!switchButtonFonts) return;

    switchButtonFonts.addEventListener('click', (event: Event) => {
        if (event.target instanceof HTMLButtonElement && event.target.dataset.href) {
            window.location.href = event.target.dataset.href;
        }
    });
};
